import { render, staticRenderFns } from "./OnboardingInvitesRequired.vue?vue&type=template&id=3a05a0ce&"
import script from "./OnboardingInvitesRequired.vue?vue&type=script&lang=js&"
export * from "./OnboardingInvitesRequired.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports